import http from "@/common/http-common";
import store from "@/store";

class EnergySourceService {
  async loadAll() {
    return http().get("/api/v1/energy_sources.json").then(function(resp) {
      console.log("Inside EnergySourceService.loadAll, resp.data ==> ", resp.data);
      store.commit("updateEnergySources", resp.data);
    })

  }
}

export default new EnergySourceService();